export default class GptFineTuneStatuses {
  static FAILED = "FAILED";

  static SUCCEEDED = "SUCCEEDED";
}
